/**
 * Decide whether a navigation to `/queue` should be redirected into the Focused
 * Lead View.
 *
 * When the rep has opted into Focused View, the queue experience *is* Focused
 * View, so every `/queue` entry point (top nav, logo, card clicks, inbound-call
 * landing) lands there instead of the legacy queue.
 *
 * Exception: Tyson practice mode (`/queue?tysonMode=true`). Focused View does
 * not host the practice-lead flow yet, so practice sessions must stay on the
 * legacy queue regardless of the opt-in.
 */
export function shouldUseFocusedViewForQueue({
	focusedViewEnabled,
	isTysonMode,
}: {
	focusedViewEnabled: boolean;
	isTysonMode: boolean;
}): boolean {
	return focusedViewEnabled && !isTysonMode;
}
